import { useAuth } from 'src/shared/hooks/authProvider'
import {
  useLikesApi,
  useUserLikesApi,
  useToggleLikeApi,
} from 'src/api/db/apiLikes'

export const useProductLikes = (productId: number | undefined) => {
  const { session } = useAuth()
  const { likeCounts } = useLikesApi({
    productIds: productId ? [productId] : [],
  })
  const { userLikes } = useUserLikesApi({
    productIds: productId ? [productId] : [],
  })
  const { toggleLike } = useToggleLikeApi()

  const likeCount = productId ? likeCounts.get(productId) || 0 : 0
  const isLiked = productId ? userLikes.has(productId) : false
  const isAuthenticated = !!session?.user?.id

  const handleToggleLike = () => {
    if (!productId) return
    toggleLike.mutate({
      productId,
      currentLikeState: isLiked,
    })
  }

  return {
    likeCount,
    isLiked,
    isAuthenticated,
    toggleLike: handleToggleLike,
    toggleLikePending: toggleLike.isPending,
  }
}

